import React, {useContext} from 'react';
import {Grid, Typography, SvgIcon} from '@material-ui/core';
import {Checkbox} from '@mantine/core';
import {useFormikContext} from "formik";
import {makeStyles} from "@material-ui/core/styles";
import PopOverDetails from "../../../../../PopOverInfo";
import HikingIcon from '@mui/icons-material/Hiking';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import CallIcon from '@mui/icons-material/Call';
import AffinityInfoContext from "../../../../../../context/AffinityContext";
import MantineNumberField from "../../../../FormikUtils/MantineNumberField";
import {IconBike, IconCamera, IconDeviceLaptop, IconDeviceTablet, IconScooter} from "@tabler/icons";

const useStyles = makeStyles((theme) => ({
    coverageIcon: {
        width: "32px",
        height: "32px",
        strokeWidth: "2px",
    },
    tableRowLabelAditional: {
        fontFamily: 'EncodeSansRegular',
        fontSize: 14,
        maxWidth: "90%"
    },
    coberturasTable: {
        padding: theme.spacing(1),
    },
    tableHeader: {
        fontFamily: 'EncodeSansBold',
        fontSize: 18
    },
    tableRowLabel: {
        fontFamily: 'EncodeSansRegular',
        fontSize: 12,
        maxWidth: "90%"
    },
    centerContent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    noCost: {
        fontFamily: 'EncodeSansBold',
        fontSize: "12px",
        textAlign: "center"
    },
}));

export default function CoberturasFormMobile() {
    const {coberturasInfo} = useContext(AffinityInfoContext);
    const classes = useStyles();
    const {values, setFieldValue} = useFormikContext();
    const noCostCoverages = [
        {selected: true, numeroCobertura: "44", sumaAsegurada: "Sin Costo", icon: HikingIcon},
        {selected: true, numeroCobertura: "45", sumaAsegurada: "Sin Costo", icon: MedicalServicesIcon},
        {selected: true, numeroCobertura: "50", sumaAsegurada: "Sin Costo", icon: CallIcon},
    ];
    const coberturasAdicionalesIcons = {
        26: <IconCamera className={classes.coverageIcon}/>,
        36: <IconDeviceLaptop className={classes.coverageIcon}/>,
        37: <IconDeviceTablet className={classes.coverageIcon}/>,
        48: <IconBike className={classes.coverageIcon}/>,
        49: <IconScooter className={classes.coverageIcon}/>,
    }

    return (
        <React.Fragment>
            <Grid container direction='column'>
                <Grid item container spacing={3} direction='column' className={classes.coberturasTable}>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        margin: "8px 16px",
                    }}>
                        <Typography className={classes.tableHeader}>Cobertura</Typography>
                        <Typography className={classes.tableHeader}>Suma Asegurada</Typography>
                    </div>
                    <Grid item container spacing={3} direction='column' className={classes.coberturasTable}>
                        {Object.keys(values.coberturas).map(cobertura => {
                            return (
                                <>
                                    <div style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        margin: "16px",
                                    }}>
                                        <div style={{
                                            width: "60%", display: "flex",
                                            flexDirection: "row", alignItems: "center", justifyContent: "space-between",
                                        }}>
                                            <div style={{width: "15%", marginLeft: "-8px"}}>
                                                <Checkbox
                                                    checked={values.coberturas[cobertura].selectedCobertura}
                                                    classNames={{
                                                        input: "checkbox",
                                                        root: "checkbox",
                                                        body: "checkbox",
                                                    }}
                                                    size="sm"
                                                    onChange={(e) => {
                                                        const {checked} = e.target;
                                                        setFieldValue(`coberturas.[${cobertura}].selectedCobertura`, checked);
                                                    }}
                                                />
                                            </div>

                                            <div style={{
                                                width: "15%",
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "center",
                                            }}>
                                                <Grid item xs={2} className={classes.centerContent}>
                                                    {coberturasAdicionalesIcons[cobertura]}
                                                </Grid>
                                            </div>

                                            <div style={{width: "60%"}}>

                                                <Typography className={classes.tableRowLabel}>
                                                    {coberturasInfo[cobertura].descripcion}
                                                </Typography>

                                            </div>

                                        </div>

                                        <div style={{
                                            visibility: values.coberturas[cobertura] && values.coberturas[cobertura].selectedCobertura ? "visible" : "hidden",
                                            width: "30%"
                                        }}>
                                            <MantineNumberField
                                                name={`coberturas.${cobertura}.sumaAsegurada`}
                                                min={coberturasInfo[cobertura]['sumaMinima']}
                                                max={coberturasInfo[cobertura]['sumaMaxima']}
                                                styles={{input: {textAlign: "right", fontSize: "12px"}}}
                                            />

                                        </div>
                                        <div style={{width: "10%"}}>
                                            <PopOverDetails
                                                descripcion={coberturasInfo[cobertura].descripcionCompleta}
                                                isMobile={true}
                                            />
                                        </div>
                                    </div>
                                </>
                            )
                        })}


                        {noCostCoverages.map((item) => (
                            <div style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                margin: "16px",
                            }}>
                                <div style={{
                                    width: "60%", display: "flex",
                                    flexDirection: "row", alignItems: "center", justifyContent: "space-between",
                                }}>
                                    <div style={{width: "15%", marginLeft: "-8px"}}>
                                        <Checkbox
                                            checked={true}
                                            classNames={{
                                                input: "checkbox",
                                                root: "checkbox",
                                                body: "checkbox",
                                            }}
                                            size="sm"
                                        />
                                    </div>

                                    <div style={{
                                        width: "15%",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "center"
                                    }}>
                                        <Grid item xs={2} className={classes.centerContent}>
                                            <SvgIcon component={item.icon}
                                                     fontSize="large"
                                                     style={{
                                                         width: "32px",
                                                         height: "32px",
                                                     }}
                                            />
                                        </Grid>
                                    </div>

                                    <div style={{width: "60%"}}>
                                        <Typography className={classes.tableRowLabel}>
                                            {coberturasInfo[item.numeroCobertura].descripcion}
                                        </Typography>
                                    </div>

                                </div>

                                <div style={{width: "30%"}}>
                                    <p className={classes.noCost}>Sin costo</p>
                                </div>

                                <div style={{width: "10%"}}>
                                    <PopOverDetails
                                        descripcion={coberturasInfo[item.numeroCobertura].descripcionCompleta}
                                        isMobile={true}/>
                                </div>
                            </div>
                        ))}
                    </Grid>

                </Grid>
            </Grid>
        </React.Fragment>
    );
}
